import {
  AirHandlerTypeCodeType,
  HyperHeatFilterValueType,
  SystemTypeFilterValueType
} from 'data/types';

export type EquipmentFilterState = {
  configIds: string[] | null;
  airHandlerTypes: AirHandlerTypeCodeType[] | null;
  condenserSeries: string[] | null;
  condenserBtus: number[] | null;
  hyperHeat: HyperHeatFilterValueType[] | null;
  systemTypes: SystemTypeFilterValueType[] | null;
  refrigerants: string[] | null;
};

export const defaultEquipmentFilters: EquipmentFilterState = {
  configIds: null,
  airHandlerTypes: null,
  condenserSeries: null,
  condenserBtus: null,
  hyperHeat: null,
  systemTypes: null,
  refrigerants: null
};

export type EquipmentFilterMemoryState = {
  configIds: string[];
  airHandlerTypes: AirHandlerTypeCodeType[];
  condenserSeries: string[];
  condenserBtus: number[];
  hyperHeat: HyperHeatFilterValueType[];
  systemTypes: SystemTypeFilterValueType[];
  refrigerants: string[];
};

export const defaultEquipmentFilterMemory: EquipmentFilterMemoryState = {
  configIds: [],
  airHandlerTypes: [],
  condenserSeries: [],
  condenserBtus: [],
  hyperHeat: [],
  systemTypes: [],
  refrigerants: []
};
